import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);
import store from "./index";

import uid from "uniqid";

export default {
  //!   Login User
  async LOGIN({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/LOGIN", {
        session: uid(),
        uid: data.uid,
        password: data.password,
      });
      if (responce.data.statusCode == 200) {
        commit("SET_LOGIN", responce.data);
        commit("SET_CATEGORY", responce.data.categoryList);
        commit("SET_VENDORS", responce.data.vendorList);
        commit("SET_PRODUCTS", responce.data.productList);
        commit("SET_STOCKROOM", responce.data.storeroomList);
        // commit("SET_SHOP_DATA", responce.data.stockList);
        commit("SET_BILLS", responce.data.allBills);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  //!   logout
  async LOGOUT({ state, commit }) {
    try {
      let responce = await axios.post(state.localhost + "/LOGOUT", {
        session: store._vm.$session.get("token"),
        uid: store._vm.$session.get("uid"),
      });
      if (responce.data.statusCode == 200) {
        commit("UNSET_LOGIN");
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  //! REFRESH DATA
  async GET_ALL({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/GET_ALL", data);
      if (responce.data.statusCode == 200) {
        commit("SET_CATEGORY", responce.data.categoryList);
        commit("SET_VENDORS", responce.data.vendorList);
        commit("SET_PRODUCTS", responce.data.productList);
        commit("SET_STOCKROOM", responce.data.storeroomList);
        // commit("SET_SHOP_DATA", responce.data.stockList);
        commit("SET_BILLS", responce.data.allBills);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  //!   CATEGORY
  async GET_CATEGORY({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/CATEGORY", data);
      if (responce.data.statusCode == 200) {
        commit("SET_CATEGORY", responce.data.categoryList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async NEW_CATEGORY({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/CATEGORY/NEW", data);
      if (responce.data.statusCode == 200) {
        commit("SET_INFO", responce.data.message);
        commit("SET_CATEGORY", responce.data.categoryList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async UPDATE_CATEGORY({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/CATEGORY/UPDATE",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_INFO", responce.data.message);
        commit("SET_CATEGORY", responce.data.categoryList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async DELETE_CATEGORY({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/CATEGORY/DELETE",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_INFO", responce.data.message);
        commit("SET_CATEGORY", responce.data.categoryList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  //!   PRODUCTS
  async GET_PRODUCTS({ state, commit }) {
    try {
      let responce = await axios.post(state.localhost + "/PRODUCTS");
      if (responce.data.statusCode == 200) {
        commit("SET_VENDORS", responce.data.vendorList);
        commit("SET_PRODUCTS", responce.data.productList);
        commit("SET_CATEGORY", responce.data.categoryList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async NEW_PRODUCT({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/PRODUCTS/NEW", data);
      if (responce.data.statusCode == 200) {
        commit("SET_PRODUCTS", responce.data.productList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async EDIT_PRODUCTS({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/PRODUCTS/EDIT", data);
      if (responce.data.statusCode == 200) {
        commit("SET_PRODUCTS", responce.data.productList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async DELETE_PRODUCTS({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/PRODUCTS/DELETE",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_PRODUCTS", responce.data.productList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  //! VENDORS
  async GET_VENDORS({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/VENDORS", data);
      if (responce.data.statusCode == 200) {
        commit("SET_VENDORS", responce.data.vendorList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },

  async NEW_VENDORS({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/VENDORS/NEW", data);
      if (responce.data.statusCode == 200) {
        commit("SET_VENDORS", responce.data.vendorList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async UPDATE_VENDORS({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/VENDORS/UPDATE",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_VENDORS", responce.data.vendorList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async DELETE_VENDORS({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/VENDORS/DELETE",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_VENDORS", responce.data.vendorList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async GET_PRODUCT_LIST({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/VENDORS/PRODUCT_LIST",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_PRODUCTS_LIST_VENDOR", responce.data.prod_list);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async ADD_NEW_STOCK({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/VENDORS/UPDATE_STOCK",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_STOCKROOM", responce.data.storeroomList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  //! STORE ROOM
  async GET_STOREROOM({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/STOREROOM", data);
      if (responce.data.statusCode == 200) {
        commit("SET_PRODUCTS", responce.data.productList);
        commit("SET_STOCKROOM", responce.data.storeroomList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async NEW_STOREROOM({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/STOREROOM/NEW", data);
      if (responce.data.statusCode == 200) {
        commit("SET_STOCKROOM", responce.data.storeroomList);
        commit("SET_PRODUCTS", responce.data.productList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async DELETE_STOCK({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/STOREROOM/DELETE",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_STOCKROOM", responce.data.storeroomList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async GET_MRPS_STOCK({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/STOREROOM/GET_STOCK",
        data
      );
      if (responce.data.statusCode == 200) {
        console.log(responce.data);
        commit("SET_MRPS_STOCK", responce.data.mrpList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },

  async UPDATE_STOCK_ITEMS_UPDATE({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/STOREROOM/UPDATE_STOCK_ITEM",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_MRPS_STOCK", responce.data.mrpList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async REMOVE_STOCK_ITEMS_UPDATE({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/STOREROOM/REMOVE_STOCK_ITEM",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_MRPS_STOCK", responce.data.mrpList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  //! SHOP
  // async GET_SHOP({ state, commit }, data) {
  //   try {
  //     let responce = await axios.post(state.localhost + "/SHOP", data);
  //     if (responce.data.statusCode == 200) {
  //       commit("SET_SHOP_DATA", responce.data.stockList);
  //     } else {
  //       commit("SET_INFO", responce.data.message);
  //     }
  //   } catch (error) {
  //     commit("SET_ERROR", error);
  //   }
  // },
  // async UPDATE_SHOP({ state, commit }, data) {
  //   try {
  //     let responce = await axios.post(state.localhost + "/SHOP/UPDATE", data);
  //     if (responce.data.statusCode == 200) {
  //       commit("SET_SHOP_DATA", responce.data.stockList);
  //       commit("SET_INFO", responce.data.message);
  //     } else {
  //       commit("SET_INFO", responce.data.message);
  //     }
  //   } catch (error) {
  //     commit("SET_ERROR", error);
  //   }
  // },
  //! BILLING
  async GET_BILLING({ state, commit }) {
    try {
      let responce = await axios.post(state.localhost + "/BILLING");
      if (responce.data.statusCode == 200) {
        commit("SET_BILL_STOCK", responce.data.stockList);
        commit("SET_PRODUCTS", responce.data.productList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async GET_BILLING_NEW({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/BILLING/NEW", data);
      if (responce.data.statusCode == 200) {
        commit("SET_INFO", responce.data.message);
        commit("SET_BILL_STOCK", responce.data.stockList);
        commit("SET_PRODUCTS", responce.data.productList);
        commit("SET_BILLS", responce.data.allBills);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async GET_ALLBILLS({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/BILLING/BILLS", data);
      if (responce.data.statusCode == 200) {
        commit("SET_BILLS", responce.data.allBills);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async GET_PRINT_BILL({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/BILLING/BILLITEMS",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_PRINT_BILLS", responce.data.billItem);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  //! admin auth
  async NEW_USER({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/REGISTER/NEW", data);
      if (responce.data.statusCode == 200) {
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  //! Change password
  async CHANGE_PASSWORD({ state, commit }, data) {
    try {
      let responce = await axios.post(state.localhost + "/CHANGE", data);
      if (responce.data.statusCode == 200) {
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },

  //! ONLINE E COM
  async GET_ONLINE_CATEGORY({ state, commit }) {
    try {
      let responce = await axios.get(
        state.localhost + "/ONLINE/ADMIN/ONLINE_CATEGORY"
      );
      if (responce.data.statusCode == 200) {
        commit("SET_ONLINE_CATEGORY", responce.data.categryList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async NEW_ONLINE_CATEGORY({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/ONLINE/ADMIN/ONLINE_CATEGORY",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_INFO", responce.data.message);
        commit("SET_ONLINE_CATEGORY", responce.data.categryList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async UPDATE_ONLINE_CATEGORY({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/ONLINE/ADMIN/ONLINE_CATEGORY/UPDATE",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_INFO", responce.data.message);
        commit("SET_ONLINE_CATEGORY", responce.data.categryList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async UPLOAD_ONLINE_CATEGORY_IMAGE({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/ONLINE/ADMIN/ONLINE_CATEGORY/IMAGE",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (responce.data.statusCode == 200) {
        commit("SET_ONLINE_CATEGORY", responce.data.categryList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async REMOVE_ONLINE_CATEGORY({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/ONLINE/ADMIN/ONLINE_CATEGORY/REMOVE",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_ONLINE_CATEGORY", responce.data.categryList);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async GET_ONLINE_PRODUCTS({ state, commit }, data) {
    try {
      let responce = await axios.get(
        state.localhost + "/ONLINE/ADMIN/PRODUCTS",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_ONLINE_PRODUCTS", responce.data.productItems);
        commit("SET_ONLINE_CATEGORY", responce.data.categryList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async UPDATE_ONLINE_PRODUCTS({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/ONLINE/ADMIN/PRODUCTS/UPDATE",
        data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_ONLINE_PRODUCTS", responce.data.productItems);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async UPLOAD_ONLINE_IMAGE({ state, commit }, data) {
    try {
      let responce = await axios.post(
        state.localhost + "/ONLINE/ADMIN/PRODUCTS/IMAGE",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (responce.data.statusCode == 200) {
        commit("SET_ONLINE_PRODUCTS", responce.data.productItems);
        commit("SET_INFO", responce.data.message);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async GET_ONLINE_ORDERS({ state, commit }) {
    try {
      let responce = await axios.get(state.localhost + "/ONLINE/ADMIN/ORDERS");
      if (responce.data.statusCode == 200) {
        commit("SET_ONLINE_ORDER", responce.data.orderList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
  async GET_ONLINE_ORDERS_ITEMS({ state, commit }, data) {
    try {
      let responce = await axios.get(
        state.localhost + "/ONLINE/ADMIN/ORDERS/" + data
      );
      if (responce.data.statusCode == 200) {
        commit("SET_ONLINE_ORDER_ITEMS", responce.data.orderItemsList);
      } else {
        commit("SET_INFO", responce.data.message);
      }
    } catch (error) {
      commit("SET_ERROR", error);
    }
  },
};
